import Instance from "../../../../Axios";

// New Actions for the app

const GetObrasAHDProjetosTotaisPenalizados = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/ahd/totalPenalizados`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({
        type: "GET_OBRAS_AHD_PROJETOS_TOTAIS_PENALIZADOS",
        payload: data.yData[0].total,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasAHDProjetosTotaisPenalizados;
